module.exports = __webpack_public_path__ + "img/Argoslogo.fba7e454.svg";